import { createSlice } from "@reduxjs/toolkit";
import ReducerRegistry from "../base/redux/ReducerRegistry";
import { getConferenceState } from "../base/conference/functions";
import { MEDIA_TYPE } from "../base/media/constants";
import { isLocalTrackMuted } from "../base/tracks/functions.any";
import { NOTIFICATION_TIMEOUT_TYPE, showNotification } from "../notifications";
export const sendCommand = (command, value, needStore = false) => (_, getState) => {
    try {
        const state = getState();
        const { conference } = getConferenceState(state);
        conference?.sendModCommand(command, value, needStore);
    }
    catch (error) {
        console.error(error);
    }
};
export const sendDirectCommand = (id, command, value, needStore = false) => (_, getState) => {
    const state = getState();
    const { conference } = getConferenceState(state);
    conference?.sendDirectCommand(id, command, value, needStore);
};
export const sendNotifyMuteMedia = (mediaType, dispatch, getState) => {
    const state = getState();
    const tracks = state['features/base/tracks'];
    const muteAudio = isLocalTrackMuted(tracks, MEDIA_TYPE.AUDIO);
    const muteVideo = isLocalTrackMuted(tracks, MEDIA_TYPE.VIDEO);
    if ((mediaType === MEDIA_TYPE.AUDIO && !muteAudio) || (mediaType === MEDIA_TYPE.VIDEO && !muteVideo)) {
        dispatch(showNotification({
            titleKey: mediaType === MEDIA_TYPE.AUDIO ? 'notify.mutedRemotelyTitle' : 'notify.videoMutedRemotelyTitle',
        }, NOTIFICATION_TIMEOUT_TYPE.MEDIUM));
    }
};
const initialState = {
    commandHistory: {}
};
// Slice for file upload moderation
const modCommand = createSlice({
    name: 'features/moderation-command',
    initialState,
    reducers: {
        addCommand: (state, action) => {
            const command = action.payload;
            if (!state.commandHistory) {
                state.commandHistory = {};
            }
            state.commandHistory[command.command] = command;
        },
        removeCommand: (state, action) => {
            const command = action.payload;
            if (!state.commandHistory) {
                state.commandHistory = {};
            }
            state.commandHistory[command] = null;
        },
    }
});
ReducerRegistry.register('features/moderation-command', modCommand.reducer);
export const { addCommand, removeCommand } = modCommand.actions;
export default modCommand.reducer;
